<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import Repositories from "@/repositories";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Steps configuration",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      }
    ]
  },
  components: {
    Layout,
    PageHeader,
    Loading,
    Switches,
    Multiselect
  },
  data() {
    return {
      title: "Steps configuration",
      items: [],
      image: '',
      configuration: {
        stepResources: [],
        allowDeliveryDateModification: null,
        idPublic: null,
        installationDateModificationEmails: null,
        installationDateModificationMessage: null,
        mailToEmails: "",
        emailLanguage: "",
        hasInitialNotification: false,
        showInstallationDate: false,
        showDeliveryDate: false
      },
      isLoading: false,
      languages: [
        "en - fr",
        "en",
        "fr"
      ],
      repository: null
    };
  },
  methods: {
    save() {
      this.isLoading = true;
      var updateRequestData = { ...this.configuration };
      updateRequestData.imageUsine = this.image;
      this.repository.update(updateRequestData, "").then((response) => {
        this.configuration = { ...this.configuration, ...response.data };
        this.image = response.data.imageUsine;
      }, (error) => {
        window.console.error(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    discard() {
      this.loadData();
    },
    loadData() {
      this.isLoading = true;
      this.repository.get("").then((response) => {
        this.configuration = { ...this.configuration, ...response.data };
        this.image = response.data.imageUsine;
      }, (error) => {
        window.console.error(error);
      })
        .finally(() => {
          this.isLoading = false;
        });
    },
    filesChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.image = '';
    }
  },
  computed: {
  },
  created() {
    this.repository = Repositories.get("organisationconfiguration", this.$route.params.organisationcode);
    this.loadData();
  },
  watch: {
    "configuration.showDeliveryDate": function (val) {
      if (!val) {
        this.configuration.allowDeliveryDateModification = false;
      }
    }
  },
  mounted() { }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div style="flex: 1 1 1px; display: flex; flex-direction: column; margin:0 -24px -60px -24px;">
      <div class="p-2 pl-4 pr-4 pb-2" style="padding-right: 2.5rem !important; padding-bottom:0 !important;">
        <div style="padding: 20px; background: white; border-bottom: 1px solid rgba(204,204,204,.8);">
          <b-button @click="save" variant="success" class="mr-2">{{ $t('general.save') }}</b-button>
          <b-button @click="discard" variant="light">{{ $t('general.discard') }}</b-button>
        </div>
      </div>
      <div class="p-2 pl-4 pr-4" style="flex:1 1 1px; min-height:0; overflow-y:scroll; position:relative;">
        <div class="card">
          <div class="card-body" style="position:relative;">
            <loading :active.sync="isLoading" :can-cancel="false" color='#f1b44c' :width=70 :height=70 loader='dots'
              :is-full-page="true">
            </loading>
            <div class="row">
              <h4 class="card-title">{{ $t("general.orderstatus") }}</h4>
            </div>
            <div style="display:flex;flex-wrap:wrap;">
              <div
                style="display:flex;flex-basis:50%;justify-content:space-around;padding-left:2em;padding-right:2em;margin-top:1em;">
                <div style="flex-basis:20%;">
                  <span> </span>
                </div>
                <div style="align-self:center;flex-basis:8%;">
                  <label style="align-self:center;">{{ $t("general.track") }}</label>
                </div>
                <div style="align-self:center;flex-basis:10%;">
                  <label style="align-self:center;">{{ $t("general.notify") }}</label>
                </div>
                <div style="align-self:center;flex-basis:20%;">
                  <label style="align-self:center;">{{ $t("general.description") }}</label>
                </div>
              </div>
              <div
                style="display:flex;flex-basis:50%;justify-content:space-around;padding-left:2em;padding-right:2em;margin-top:1em;">
                <div style="flex-basis:20%;">
                  <span> </span>
                </div>
                <div style="align-self:center;flex-basis:8%;">
                  <label style="align-self:center;">{{ $t("general.track") }}</label>
                </div>
                <div style="align-self:center;flex-basis:10%;">
                  <label style="align-self:center;">{{ $t("general.notify") }}</label>
                </div>
                <div style="align-self:center;flex-basis:20%;">
                  <label style="align-self:center;">{{ $t("general.description") }}</label>
                </div>
              </div>
              <div v-for="step in configuration.stepResources" :key="step.idPublic"
                style="display:flex;flex-basis:50%;justify-content:space-around;padding-left:2em;padding-right:2em;margin-top:1em;">
                <div style="display:flex;flex-basis:20%;align-self:center">
                  <span>{{ step.station }}</span>
                </div>
                <div style="display:flex;align-self:center;">
                  <switches v-model="step.isVisible" type-bold="false" :color="step.isVisible ? 'success' : 'danger'"
                    style="align-self:center;margin-top:20px;"></switches>
                </div>
                <div style="align-self:center;">
                  <switches v-model="step.hasNotification" type-bold="false"
                    :color="step.hasNotification ? 'success' : 'danger'" style="align-self:center;margin-top:20px;">
                  </switches>
                </div>
                <div style="display:flex;align-self:center;">
                  <b-input v-model="step.description" style="align-self:center;"></b-input>
                </div>
              </div>
            </div>
            <div class="row">
              <b-form-checkbox v-model="configuration.hasInitialNotification" class="mb-3" plain>{{
                $t("steps.hasinitialnotification") }}</b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body" style="position:relative;">
            <div class="row">
              <b-form-checkbox v-model="configuration.showInstallationDate" class="mb-3" plain>{{
                $t("steps.showinstallationdate") }}</b-form-checkbox>
            </div>
            <div class="row">
              <b-form-checkbox v-model="configuration.hasDeliveryDateModificationNotification" class="mb-3" plain>{{ $t("steps.hasDeliveryDateModificationNotification")
              }}</b-form-checkbox>
            </div>
            <div class="row">
              <b-form-checkbox v-model="configuration.showDeliveryDate" class="mb-3" plain>{{ $t("steps.showdeliverydate")
              }}</b-form-checkbox>
            </div>
            <div class="row">
              <b-form-checkbox v-model="configuration.allowDeliveryDateModification" class="mb-3" plain>{{
                $t("steps.allowdeliverydatemodification") }}</b-form-checkbox>
            </div>
            <div class="row">
              <label class="mb-1 mt-3 font-weight-medium">{{ $t("general.custommessage") }}</label>
              <textarea v-model="configuration.deliveryDateModificationMessage" class="form-control" rows="3"
                :disabled="!configuration.allowDeliveryDateModification" placeholder=""></textarea>
            </div>
            <div class="row">
              <label class="mb-1 mt-3 font-weight-medium">{{ $t("general.notificationemail") }}</label>
              <input v-model="configuration.deliveryDateModificationEmails"
                :disabled="!configuration.allowDeliveryDateModification" type="text" class="form-control" />
            </div>
            <div class="row">
              <label class="mb-1 mt-3 font-weight-medium">{{ $t("general.contactemail") }}</label>
              <input v-model="configuration.mailToEmails" type="text" class="form-control" />
            </div>
            <div class="row">
              <label class="mb-1 mt-3 font-weight-medium">{{ $t("general.emaillanguage") }}</label>
              <multiselect v-model="configuration.emailLanguage" :options="languages" :show-labels="false"
                :allow-empty="false" placeholder=""></multiselect>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="image" style="display:flex;flex-direction:row;">
                <router-link tag="a" to="" class="logo logo-light">
                  <span class="logo-lg">
                    <img :src="image" alt height="25" />
                  </span>
                </router-link>
                <b-button @click="removeImage" variant="danger" class="mr-2"
                  style="height:36px;align-self:center;margin-left:15px;">{{ $t('general.delete') }}</b-button>
              </div>
            </div>
            <div class="row" style="padding-bottom:40px;">
              <label class="mb-1 mt-3 font-weight-medium">{{ $t("general.logo") }}</label>
              <div class="custom-file">
                <input id="customFile" type="file" class="custom-file-input" accept="image/*"
                  @change="filesChange($event)" />
                <label class="custom-file-label" for="customFile">Choose file</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped></style>